export default class PersonalityQuizParticipationQuestionModel {
  public questionId: number = null;
  public optionId: number = null;
}
